import { Component, OnInit, ViewChild, ComponentFactoryResolver, AfterViewInit, OnDestroy, ComponentRef } from '@angular/core';
import { ConfigService } from 'src/app/modules/core/services/config.service';
import { IConfig } from 'src/app/modules/core/interfaces/config';
import { IMainLayout } from '../../interfaces/main-layout';
import { MainLayoutProviderService } from '../../services/main-layout-provider.service';
import { environment } from 'src/environments/environment';
import { ComponentHostDirective } from 'src/app/modules/core/directives/component-host.directive';
import { CacheService } from 'projects/common/src/app/services';
import { Router } from '@angular/router';
import { InitNavigationService } from 'src/app/modules/app/services/init-navigation.service';

@Component({
  selector: 'app-default-main-layout',
  templateUrl: './default-main-layout.component.html',
  styleUrls: ['./default-main-layout.component.scss']
})
export class DefaultMainLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  public config: IConfig;

  @ViewChild(ComponentHostDirective, { static: true })
  public componentHost: ComponentHostDirective;

  protected componentRef: ComponentRef<any>;

  constructor(
    private configService: ConfigService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private layoutProvider: MainLayoutProviderService,
    private cache: CacheService,
    private router: Router,
    private initNavigationService: InitNavigationService
  ) { }

  public ngOnInit(): void {
    this.config = this.configService.getConfig();
    this.initNavigationService.navigateToHome();
  }

  public ngAfterViewInit(): void {
    // TODO Conseguir layout mediante informacion en la app actual
    const component = this.layoutProvider.get('default');
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

    this.componentRef = this.componentHost.viewContainerRef.createComponent(componentFactory);
    (this.componentRef.instance as IMainLayout).config = this.config;
    this.componentRef.changeDetectorRef.detectChanges();
  }

  public ngOnDestroy(): void {
    this.componentRef.changeDetectorRef.detach();
  }
}
